import { useEffect } from "react";

function setTag(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("meta") ? "meta" : "link");
    if (selector.includes("property=")) el.setAttribute("property", selector.match(/property="([^\"]+)"/)[1]);
    else if (selector.includes("name=")) el.setAttribute("name", selector.match(/name="([^\"]+)"/)[1]);
    else if (selector.startsWith("link[rel=")) el.setAttribute("rel", selector.match(/rel="([^\"]+)"/)[1]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function Seo({ title, description, image, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Melopa Invents Pvt Ltd` : "Melopa Invents Pvt Ltd — Government Contracting & Institutional Supplies";
    document.title = fullTitle;
    if (description) setTag('meta[name="description"]', "content", description);
    setTag('meta[property="og:title"]', "content", fullTitle);
    if (description) setTag('meta[property="og:description"]', "content", description);
    if (image) setTag('meta[property="og:image"]', "content", image);
    setTag('meta[property="og:type"]', "content", "website");
    if (path) {
      const url = `https://melopainvents.com${path}`;
      setTag('meta[property="og:url"]', "content", url);
      setTag('link[rel="canonical"]', "href", url);
    }
    setTag('meta[name="twitter:card"]', "content", "summary_large_image");
  }, [title, description, image, path]);
  return null;
}
